import React, { useState, useEffect } from "react";
import auth from "services/auth";
import ls from "services/ls";
import Spinner from "elements/Spinner";
import api from "../services/api";
import "styles/_security_popup.scss";
import { __ } from "services/Translator";

import { Modal, Button } from "react-bootstrap";

// Vault image. Some webpack/file-loader setups return the URL string directly,
// others return a module object with `.default` — handle both.
const _vaultMod = require("assets/play365/images/common/coming-soon-vault.webp");
const VAULT_IMG = _vaultMod && _vaultMod.default ? _vaultMod.default : _vaultMod;

const SecurityPopup = (props) => {
  const [isAuthenticated, setIsAuthenticated] = useState(auth.isAuthenticated);
  const [security, setSecurity] = useState(null);
  const [securityPopupModal, setSecurityPopupModal] = useState(false);
  const [securityPopupData, setSecurityPopupData] = useState({
    login: "",
    password: "",
  });

  const [spinner, setSpinner] = useState(false);

  const [securityPopupDataErrors, setSecurityPopupDataErrors] = useState({
    login: "",
    password: "",
  });
  const [loginError, setLoginError] = useState("");

  // Launch notify ("Notify Me")
  const [notifyEmail, setNotifyEmail] = useState("");
  const [notifyCompany, setNotifyCompany] = useState(""); // honeypot — must stay empty
  const [notifyError, setNotifyError] = useState("");
  const [notifyLoading, setNotifyLoading] = useState(false);
  const [notifyDone, setNotifyDone] = useState(false);

  const updateSecurityPopupInput = (ev) => {
    var target = ev.target;
    var field = target.name;
    var value = target.value;
    var type = target.type;
    // updateRegistrationForm(field, value);
    setSecurityPopupData({ ...securityPopupData, [field]: value });
  };

  const securityPopupLogin = async (ev) => {
    ev.preventDefault();
    setLoginError("");
    var valid = validateSecurityPopupForm();
    if (valid) {
      setSpinner(true);
      var response = await api.post("/pre-login", securityPopupData);
      setSpinner(false);
      if (response.status == 200) {
        //Here, no actual user token is provided. So, user is still not logged in
        //However, this temporary token will get past the security popup.
        //Store it under a dedicated key too: auth.login writes it to userObj,
        //but userObj gets torn down by logout/idle-timeout (incl. from another
        //tab), which dropped the gate back on. The dedicated key survives that,
        //and api.attachAuthorizeHeader falls back to it so /ping stays 200.
        ls.set("securityBypassToken", response.data.user.accessToken);
        await auth.login(response.data.user);
        setSecurity(false);
      } else {
        setLoginError(
          (response.data && response.data.message) ||
            __("Login failed. Please check your details and try again.")
        );
      }
    }
  };

  const validateSecurityPopupForm = () => {
    var valid = true;
    // return valid;
    var errorsTmp = {};
    if (securityPopupData.login.length < 2 || securityPopupData.login.length > 250) {
      errorsTmp = { ...errorsTmp, login: __("Please enter your username") };
      valid = false;
    }

    if (securityPopupData.password.length < 2 || securityPopupData.password.length > 250) {
      errorsTmp = { ...errorsTmp, password: __("Please enter your password") };
      valid = false;
    }

    setSecurityPopupDataErrors(errorsTmp);

    return valid;
  };

  // ---- Launch notify submit (store-only via backend; honeypot + rate-limited) ----
  const submitNotify = async (ev) => {
    ev.preventDefault();
    // Honeypot: if filled, it's a bot — silently pretend success, send nothing.
    if (notifyCompany.trim() !== "") {
      setNotifyDone(true);
      return;
    }
    const email = notifyEmail.trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      setNotifyError(__("Please enter a valid email address."));
      return;
    }
    setNotifyError("");
    setNotifyLoading(true);
    try {
      var response = await api.post("/launch-subscribe", {
        email: email,
        company: notifyCompany, // honeypot field (empty for real users)
      });
      if (response.status === 200) {
        setNotifyDone(true);
      } else {
        setNotifyError(
          (response.data && response.data.message) ||
            __("Something went wrong. Please try again.")
        );
      }
    } catch (e) {
      setNotifyError(__("Something went wrong. Please try again."));
    }
    setNotifyLoading(false);
  };

  const ping = async () => {
    var response = await api.get("/ping");
    // console.log("PING", response);
    if (response.status === 200) {
      setSecurity(false);
    } else if (response.status === 403) {
      if (response.data && response.data.showSecurityPopup) {
        var userId = auth.getUserId();
        if (!userId) {
          setSecurity(true);
        }
      }
    }
  };

  useEffect(() => {
    if (!isAuthenticated) {
      ping();
    } else {
      setSecurity(false);
    }
    const interval = setInterval(() => {
      var authenticated = auth.isAuthenticated();
      if (!authenticated) {
        ping();
      }
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  const openModal = () => {
    setLoginError("");
    setSecurityPopupModal(true);
  };
  const closeModal = () => {
    setSecurityPopupModal(false);
  };

  return (
    <>
      {spinner && <Spinner />}
      {security === null ? (
        <Spinner />
      ) : security === false ? (
        <>{props.children}</>
      ) : (
        <>
          <div className="security_overlay">
            <div className="gcs_inner">
              <div className="gcs_eyebrow gcs_reveal" style={{ animationDelay: "0ms" }}>
                {__("CHASE CLOVERS · MAKE YOUR FORTUNE")}
              </div>

              <div className="gcs_brand gcs_reveal" style={{ animationDelay: "80ms" }}>
                <div className="gcs_brand_name">GOLDEN&nbsp;CLOVER</div>
                <div className="gcs_brand_sub">
                  <span className="gcs_ln" />
                  <span className="gcs_sublabel">CASINO</span>
                  <span className="gcs_ln gcs_ln_r" />
                </div>
              </div>

              <span className="gcs_badge gcs_reveal" style={{ animationDelay: "160ms" }}>
                <span className="gcs_dot" />
                {__("Launching soon")}
              </span>

              <div className="gcs_vault gcs_reveal" style={{ animationDelay: "240ms" }}>
                <span
                  className="gcs_spark"
                  style={{ top: "12%", left: "14%", width: 6, height: 6, animationDelay: "0.2s" }}
                />
                <span
                  className="gcs_spark"
                  style={{ top: "24%", right: "10%", width: 5, height: 5, animationDelay: "1.1s" }}
                />
                <span
                  className="gcs_spark"
                  style={{ top: "60%", left: "6%", width: 4, height: 4, animationDelay: "2s" }}
                />
                <img src={VAULT_IMG} alt={__("Golden Clover Casino")} />
              </div>

              <h1 className="gcs_title gcs_reveal" style={{ animationDelay: "320ms" }}>
                {__("The vault is about to open.")}
              </h1>
              <p className="gcs_sub gcs_reveal" style={{ animationDelay: "400ms" }}>
                {__(
                  "Golden Clover Casino is putting the finishing touches on a brand-new gaming experience. Be the first one in."
                )}
              </p>

              {/* Countdown UI removed per Dennis request (2026-06-24). Logic kept for future re-enable. */}

              <div className="gcs_notify_card gcs_reveal" style={{ animationDelay: "480ms" }}>
                {notifyDone ? (
                  <div className="gcs_notify_success" aria-live="polite">
                    <svg className="gcs_check" viewBox="0 0 52 52" aria-hidden="true">
                      <circle className="gcs_check_ring" cx="26" cy="26" r="23" />
                      <path className="gcs_check_tick" d="M15 27l7.5 7.5L37 19" />
                    </svg>
                    <div className="gcs_success_h">{__("You're on the list.")}</div>
                    <p className="gcs_success_p">
                      {__(
                        "We'll email you the moment the vault opens — and you'll be first to see the welcome bonus."
                      )}
                    </p>
                  </div>
                ) : (
                  <>
                    <label className="gcs_card_label" htmlFor="gcs-notify-email">
                      {__("Put me on the guest list")}
                    </label>
                    <form className="gcs_notify" onSubmit={submitNotify}>
                      {/* Honeypot — hidden from humans, bots tend to fill it */}
                      <input
                        type="text"
                        className="gcs_hp"
                        tabIndex="-1"
                        autoComplete="off"
                        name="company"
                        aria-hidden="true"
                        value={notifyCompany}
                        onChange={(e) => setNotifyCompany(e.target.value)}
                      />
                      <input
                        id="gcs-notify-email"
                        type="email"
                        name="notify_email"
                        autoComplete="email"
                        placeholder={__("you@example.com")}
                        value={notifyEmail}
                        onChange={(e) => setNotifyEmail(e.target.value)}
                        required
                      />
                      <button className="gcs_btn" type="submit" disabled={notifyLoading}>
                        {notifyLoading ? __("One moment") : __("Reserve my spot")}
                      </button>
                    </form>
                    {notifyError ? (
                      <div className="gcs_notify_error" role="alert">{notifyError}</div>
                    ) : null}
                  </>
                )}
              </div>

              <div className="gcs_reassure gcs_reveal" style={{ animationDelay: "560ms" }}>
                <span className="gcs_reassure_item">{__("No spam")}</span>
                <span className="gcs_reassure_sep" />
                <span className="gcs_reassure_item">{__("One message")}</span>
                <span className="gcs_reassure_sep" />
                <span className="gcs_reassure_item">{__("Unsubscribe in one click")}</span>
              </div>
            </div>

            <footer className="gcs_footer">
              <button type="button" className="gcs_staff" onClick={openModal}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="11" width="18" height="11" rx="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
                {__("Staff? Log in")}
              </button>
              <span className="gcs_copy">© {new Date().getFullYear()} Golden Clover Casino</span>
            </footer>
          </div>

          <Modal
            show={securityPopupModal}
            centered
            onHide={closeModal}
            backdropClassName="gcs_modal_backdrop"
            dialogClassName="gcs_modal_dialog"
            contentClassName="gcs_modal_content"
          >
            <Modal.Body className="login_modal security_popup">
              <button
                type="button"
                onClick={closeModal}
                className="modal_close"
                aria-label={__("Close")}
              >
                <i className="fal fa-times" aria-hidden="true"></i>
              </button>
              <div className="modal_headline">
                <svg
                  className="gcs_modal_lock"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  aria-hidden="true"
                >
                  <rect x="3" y="11" width="18" height="11" rx="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
                {__("Early access")}
              </div>
              <div className="gcs_modal_sub">
                {__("Staff login to preview the site.")}
              </div>
              {loginError ? (
                <div className="gcs_login_error" role="alert">{loginError}</div>
              ) : null}
              <form onSubmit={securityPopupLogin}>
                <div className="form_area">
                  <div className="input_item">
                    <label className="name" htmlFor="gcs-staff-login">
                      {__("Username")} <span className="requried_icon">*</span>
                    </label>
                    <input
                      id="gcs-staff-login"
                      type="text"
                      name="login"
                      autoComplete="username"
                      onChange={updateSecurityPopupInput}
                      value={securityPopupData.login}
                      className={"form-control name_value " + (securityPopupDataErrors.login ? "error" : "")}
                    />
                    <div className="errorMsg">{securityPopupDataErrors.login}</div>
                  </div>

                  <div className="input_item">
                    <label className="name" htmlFor="gcs-staff-password">
                      {__("Password")}
                      <span className="requried_icon">*</span>
                    </label>
                    <input
                      id="gcs-staff-password"
                      type="password"
                      name="password"
                      autoComplete="current-password"
                      onChange={updateSecurityPopupInput}
                      value={securityPopupData.password}
                      className={"form-control name_value " + (securityPopupDataErrors.password ? "error" : "")}
                    />
                    <div className="errorMsg">{securityPopupDataErrors.password}</div>
                  </div>
                  <div className="login_button">
                    <Button type="submit" className="login_btn">
                      {__("Log in")}
                    </Button>
                  </div>
                </div>
              </form>
            </Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
};

export default SecurityPopup;
